// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as LiveOrderCardModuleScss from "../styles/LiveOrderCard.module.scss";

var styles = LiveOrderCardModuleScss;

function LiveOrderCardFallBackCmp(Props) {
  return React.createElement("div", {
              className: styles["live-order-card-container-shimmer"]
            }, React.createElement("div", {
                  className: styles["live-order"]
                }, React.createElement("div", {
                      className: styles["live-shimmer"]
                    }), React.createElement("div", {
                      className: styles["text-shimmer"]
                    })), React.createElement("button", {
                  className: styles["view-status-shimmer"]
                }));
}

var make = LiveOrderCardFallBackCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
